<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.26 22H9.27C7.02 22 5.13 20.24 4.96 18L4.35 9.62C4.31 9.07 4.72 8.59 5.27 8.55C5.82 8.52 6.3 8.92 6.34 9.47L6.95 17.85C7.04 19.06 8.05 20 9.26 20H15.25C16.46 20 17.47 19.06 17.56 17.85L18.17 9.47C18.21 8.92 18.68 8.51 19.24 8.55C19.79 8.59 20.2 9.07 20.16 9.62L19.55 18C19.39 20.24 17.5 22 15.25 22H15.26ZM13.75 17.29C13.2 17.29 12.75 16.84 12.75 16.29V11.78C12.75 11.23 13.2 10.78 13.75 10.78C14.3 10.78 14.75 11.23 14.75 11.78V16.29C14.75 16.84 14.3 17.29 13.75 17.29ZM10.37 17.29C9.82 17.29 9.37 16.84 9.37 16.29V11.78C9.37 11.23 9.82 10.78 10.37 10.78C10.92 10.78 11.37 11.23 11.37 11.78V16.29C11.37 16.84 10.92 17.29 10.37 17.29ZM20.53 7.4H4C3.45 7.4 3 6.95 3 6.4C3 5.85 3.45 5.4 4 5.4H7.68L8.02 3.73C8.3 2.69 9.19 2 10.21 2H14.34C15.35 2 16.25 2.69 16.51 3.67L16.86 5.41H20.54C21.09 5.41 21.54 5.86 21.54 6.41C21.54 6.96 21.09 7.41 20.54 7.41L20.53 7.4ZM9.72 5.4H14.82L14.56 4.12C14.56 4.12 14.45 4 14.34 4H10.22C10.13 4 10 4.08 9.97 4.18L9.73 5.4H9.72Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup></script>
